import { useLocation } from 'preact-iso';
import { useMemo } from 'preact/hooks';
import { classNames } from '../../utils/helpers';
import { trackBottomNavClick } from '../../utils/plausible-events';
import { ButtonBar } from '../button-bar';

const BottomNavBar = ({ isHidden = false }) => {
  const buttons = useMemo(
    () =>
      [
        { id: '/now', children: 'Listen Now' },
        { id: '/library', children: 'Library' },
        { id: '/search', children: 'Search' },
        { id: '/pricing-in-app', children: 'Pricing' },
      ] as const,
    []
  );
  const ids = buttons.map((b) => b.id);
  type ButtonId = (typeof buttons)[number]['id'];
  const { path, route } = useLocation();
  let selectedId: ButtonId | null;
  if (ids.includes(path)) {
    selectedId = path as ButtonId;
  } else {
    selectedId = null;
  }
  const setSelectedId = (id: ButtonId) => {
    if (id !== selectedId) {
      route(id);
      trackBottomNavClick(id);
    }
  };
  return (
    <nav
      class={classNames(
        'fixed bottom-0 flex h-[var(--bottom-nav-height)] w-full items-start',
        'transition-transform duration-300 ease-[ease]',
        'border-t border-slate-400/20',
        isHidden && 'translate-y-full'
      )}
    >
      <ButtonBar
        buttons={buttons}
        selectedId={selectedId}
        onSelect={setSelectedId}
        buttonClassName="py-1 h-[calc(var(--bottom-nav-height)-var(--safe-area-bottom)-1px)] w-1/4 mt-0"
      />
    </nav>
  );
};

export default BottomNavBar;
